<template>
  <div>
    <!-- sorry -->
    <div class="only-mobile img-navbar-container">
      <img
        src="~@/assets/images/SARAH3.png"
        alt="Rede SARAH de Hospitais de Reabilitação - Associação das Pioneiras Sociais"
        class="img-navbar only-mobile"
        :class="{ 'invert-color': isHighContrast }"
      />
    </div>
    <b-navbar :mobile-burger="false">
      <template #brand>
        <b-navbar-item
          class="only-mobile"
          @click="sidebarModel = !sidebarModel"
          v-if="isSidebarAvaliable()"
        >
          <a
            role="button"
            aria-label="menu"
            class="navbar-burger burger"
            :class="{ 'is-active': sidebarModel }"
          >
            <span aria-hidden="true" />
            <span aria-hidden="true" />
            <span aria-hidden="true" />
          </a>
        </b-navbar-item>
        <b-navbar-item
          :class="isSidebarAvaliable() ? 'logo' : 'logo-center'"
          tag="router-link"
          :to="{ path: '/inicio' }"
        >
          <img
            src="~@/assets/images/logo_extended_orange.svg"
            alt="Rede SARAH de Hospitais de Reabilitação - Associação das Pioneiras Sociais"
            class="only-desktop"
            :class="{ 'invert-color': isHighContrast }"
          />
        </b-navbar-item>
        <b-navbar-item tag="div" class="view-desktop mini-menu-group">
          <ul class="menu align-right">
            <li>
              <contrast-button />
            </li>
            <li class="text-smaller" @click="doZoom('out')">
              <img
                src="~@/assets/images/icons/ic_text_decrease.svg"
                class="invert-on-highcontrast"
                alt="Diminuir fonte"
              />
            </li>
            <li class="text-larger" @click="doZoom('in')">
              <img
                src="~@/assets/images/icons/ic_text_increase.svg"
                class="invert-on-highcontrast"
                alt="Aumentar fonte"
              />
            </li>
          </ul>
        </b-navbar-item>

        <b-sidebar
          type="is-light"
          :open.sync="sidebarModel"
          :fullheight="true"
          :overlay="true"
          :class="{
            'highcontrast-active': $store.getters.isHighContrastSelected
          }"
        >
          <b-menu :activable="false">
            <div class="config-items">
              <contrast-button :label="$t('botoes.alto-contraste')" />
            </div>
            <div class="separator" />
            <b-menu-list>
              <template
                v-for="(option, index) in menuOptions.filter((m) =>
                  m.isActive()
                )"
              >
                <b-menu-item
                  :key="index"
                  :aria-role="option.ariaRole"
                  v-if="option.isActive()"
                  @click="sidebarAction(option.action)"
                  :label="option.description"
                />
              </template>
            </b-menu-list>
            <div class="separator" />
            <b-menu-list>
              <b-menu-item
                aria-role="listitem"
                @click="logout()"
                :label="$t('botoes.sair')"
              />
            </b-menu-list>
          </b-menu>
        </b-sidebar>
      </template>

      <template #end>
        <b-navbar-item tag="div">
          <div
            v-if="!dadosPaciente"
            class="access-button-group"
            @click="routerLinkTo('/')"
          >
            <a class="button out-blue"> Portal do paciente </a>
          </div>
          <div v-else class="access-button-group">
            <b-dropdown aria-role="list">
              <button class="button" slot="trigger">
                {{ getNomePaciente }}
                <i class="icon-ic_chevron_down_gray" />
              </button>
              <template
                v-for="(option, index) in menuOptions.filter((m) =>
                  m.isActive()
                )"
              >
                <b-dropdown-item
                  :key="index"
                  :aria-role="option.ariaRole"
                  @click="option.action()"
                >
                  {{ option.description }}
                </b-dropdown-item>
              </template>
              <b-dropdown-item aria-role="listitem" @click="logout">
                {{ $t('botoes.sair') }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </b-navbar-item>
      </template>
    </b-navbar>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import authService from '@/services/auth-service'
import {
  SET_PERFIS,
  SET_DADOS_PACIENTE,
  SET_EXAMES,
  SET_SOLICITACAO_CIRURGIA,
  SET_SOLICITACOES_CIRURGIA
} from '@/store/modules/mutation-types'
import ContrastButton from '../buttons/ContrastButton.vue'
import { UIThemesEnum } from '../../../models/ui-themes'

export default {
  components: { ContrastButton },
  name: 'MainMenu',
  data() {
    return {
      openInput: false,
      zoom: null,
      normalZoom: '100%',
      zoomIn: '125%',
      zoomOut: '75%',
      menuOptions: [
        {
          description: 'Selecionar perfil',
          isActive: () => this.perfis.length > 1,
          ariaRole: 'listitem',
          action: () => this.routerLinkTo('selecionar-paciente')
        },
        {
          description: 'Minha Agenda',
          isActive: () => !this.PacienteFalecido(),
          ariaRole: 'listitem',
          action: () => this.routerLinkTo('agenda')
        },
        {
          description: 'Exames',
          isActive: () => !this.InternadoOuFalecido(),
          ariaRole: 'listitem',
          action: () => this.routerLinkTo('resultado-de-exame')
        },
        {
          description: 'Dados Cadastrais',
          isActive: () => !this.PacienteFalecido(),
          ariaRole: 'listitem',
          action: () => this.routerLinkTo('editar-perfil')
        },
        {
          description: 'Documentos',
          isActive: () => !this.InternadoOuFalecido(),
          ariaRole: 'listitem',
          action: () => this.routerLinkTo('documentos')
        }
      ],
      sidebarModel: false
    }
  },

  computed: {
    ...mapGetters({
      perfis: 'perfis',
      dadosPaciente: 'dadosPaciente'
    }),
    getNomePaciente() {
      return this.dadosPaciente != null ? this.dadosPaciente.Nome : ''
    },
    isHighContrast() {
      return this.$store.state.ui.theme === UIThemesEnum.HIGH_CONTRAST
    }
  },
  methods: {
    ...mapMutations([
      SET_PERFIS,
      SET_DADOS_PACIENTE,
      SET_EXAMES,
      SET_SOLICITACOES_CIRURGIA,
      SET_SOLICITACAO_CIRURGIA
    ]),
    routerLinkTo(value) {
      this.$router.push(`/${value}`)
    },
    doZoom(value) {
      if (!this.zoom && value === 'in') {
        this.zoom = 'in'
        window.document.body.style.zoom = this.zoomIn
      } else if (!this.zoom && value === 'out') {
        this.zoom = 'out'
        window.document.body.style.zoom = this.zoomOut
      } else {
        this.zoom = null
        window.document.body.style.zoom = this.normalZoom
      }
    },
    logout() {
      authService.logout().then(() => {
        this.SET_PERFIS([])
        this.SET_DADOS_PACIENTE(null)
        this.SET_EXAMES(null)
        this.SET_SOLICITACOES_CIRURGIA(null)
        this.SET_SOLICITACAO_CIRURGIA(null)
        this.sidebarModel = false
        this.$router.push('/')
      })
    },
    sidebarAction(action) {
      this.sidebarModel = false
      action()
    },
    isSidebarAvaliable() {
      return this.$route.name !== 'UserAuthentication'
    },
    PacienteFalecido() {
      if (!this.dadosPaciente) return false
      return this.dadosPaciente.Falecido === 'S'
    },
    PacienteInternado() {
      if (!this.dadosPaciente) return false
      return this.dadosPaciente.Internado === 'S'
    },
    InternadoOuFalecido() {
      return this.PacienteFalecido() || this.PacienteInternado()
    }
  }
}
</script>

<style lang="scss">
@import '~@/assets/stylesheets/styleguide';

.dropdown.is-active .dropdown-menu,
.dropdown.is-hoverable:hover .dropdown-menu {
  right: 0;
  left: 0;
  .dropdown-content a.dropdown-item a {
    color: var(--black);
  }
}
.img-navbar-container {
  .img-navbar {
    position: absolute;
    left: calc(50% - 3rem);
    transform: translateX(-50%);
    z-index: 999;
    margin: 0 3rem;
  }
}

.navbar .navbar-brand {
  display: flex;
  justify-content: space-between;
}

.navbar {
  background-color: var(--bg-color-primary);
  display: block;
  padding-top: 1.1rem;
  .navbar-brand {
    display: flex;
    justify-content: space-between;
    .navbar-item {
      padding: 0;
      img {
        max-height: 100%;
        padding: 5px 0 3px 0;
      }
    }
    .logo {
      display: block;
      min-width: 25rem;
    }
    .router-link-active:not(.logo) {
      padding: 0;
      max-height: 2.5rem;
      margin-left: 0.6rem;
      img {
        min-height: 2.5rem;
      }
    }
  }
  //mini-menu
  .mini-menu-group {
    padding: 0;
    align-items: end;
    .menu {
      display: flex;
      justify-content: space-around;
      width: 8.8125rem;
      li {
        cursor: pointer;
        width: 100%;
        img,
        a {
          display: block;
          max-width: 100%;
        }
      }
    }
  }
}
.navbar-menu {
  background: transparent;
  margin: 0.5rem 0 0 0;
  border-top: 1px solid $neutral-color-4;
  border-color: var(--neutral-color-4);
  width: 100%;
  max-height: 3rem;
  .navbar-link {
    color: var(--black);
    &:after {
      border: 2.5px solid transparent;
      border-right: 0;
      border-top: 0;

      border-color: var(--neutral-color-3);
      width: 0.425em;
      height: 0.425em;
    }
    &:hover {
      color: var(--black);
      font-weight: $font-bold;

      border-bottom: 2px solid $black;
      border-color: var(--black);
      &:after {
        transform: rotate(135deg);
      }
    }
  }
  .active {
    > .navbar-link {
      color: var(--black);
    }
  }
  //dropdown items
  .navbar-dropdown {
    box-shadow: none;
    border-top: 0;
    max-width: 15rem;
    > .navbar-item {
      font-size: 1rem;
      border-bottom: 2px solid transparent;
      &:hover {
        background: transparent;
        border-bottom: 2px solid $black;
        border-color: var(--black);
      }
    }
  }
  .navbar-item.has-dropdown {
    align-items: stretch;
    &:hover {
      .navbar-link {
        font-weight: $font-bold;
        background: transparent;
        border-bottom: 2px solid $black;
        border-color: var(--black);
        &:after {
          transform: rotate(135deg);
        }
      }
    }
  }

  //access box
  .access-button-group {
    padding: 0.5rem 0 0 0;
    .button {
      margin: 0 1.125rem;
      background: transparent;
      border: none;
      font-size: 0.9rem;
      width: auto;
    }
    .out-blue {
      color: var(--secondary);
      font-weight: $font-semi-bold;
    }
  }
  //seach box
  .search-box {
    border-left: 1px solid $neutral-color-4;
    border-color: var(--neutral-color-4);
    position: relative;
    height: 1.5625rem;
    float: right;
    padding: 0 1.25rem;
    min-width: 1.875rem;
    margin-top: 0.3125rem;
  }
  .search-input {
    position: absolute;
    top: 2.1875rem;
    right: 0;

    background: var(--white);
    border-radius: 0 0 0.5rem 0.5rem;
    width: 35rem;
    z-index: 100;
    padding: 0.5rem 0.9377rem;
    &.searchClosed {
      display: none;
    }
    input {
      display: block;
      box-sizing: border-box;
      width: 100%;
      height: 2.4375rem;
      margin: 0 0 1rem;
      padding: 0.5rem;
      border: 1px solid $neutral-color-4;
      border-color: var(--neutral-color-4);
      border-radius: 0;

      background-color: var(--neutral-color-5);
      box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
      font-family: inherit;
      font-size: 1rem;
      font-weight: 400;
      line-height: 1.5;

      color: var(--gray-900);
      transition: box-shadow 0.5s, border-color 0.25s ease-in-out;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
    }
  }
  #search-icon {
    content: url(~@/assets/images/icons/ic_search.svg);
    position: absolute;
    top: 0;
    right: 0;
    width: 1.5625rem;
    height: 1.5625rem;
    &.open {
      content: url(~@/assets/images/icons/ic_close.svg);
    }
  }
}

.only-desktop {
  display: inline-block;
}
.only-mobile {
  display: none;
}

@media (max-width: $mobile-width-breakpoint) {
  .only-desktop {
    display: none;
  }

  .only-mobile {
    display: inline-block;
  }

  .navbar-brand {
    align-items: center;
  }

  .navbar .navbar-brand .navbar-item.logo {
    min-width: unset;
    margin: -5px auto 1px 9px;
  }

  .navbar {
    padding-top: 0;
    .navbar-brand .navbar-item.logo-center {
      margin: -5px auto 1px auto;
    }
  }

  $margin-top-menu: 70px;

  .sidebar-content {
    margin-top: $margin-top-menu;
  }

  .menu {
    position: relative;
    height: calc(100% - #{$margin-top-menu});
    .config-items {
      padding-left: 0.75rem;
    }
  }
}

@media (max-width: 319px) {
  .navbar .navbar-brand .navbar-item.logo {
    display: none;
  }
}

.separator {
  border-bottom: 1px solid $neutral-color-4;
  box-shadow: 0px 1px 0px 0px $neutral-color-5;
  margin: 1.5rem 0 1.25rem 0;
}

.invert-color {
  filter: invert(1);
}

.burger {
  margin-left: -12px;
  margin-top: -10px;
}
</style>
